import { createContext, useContext, useMemo } from 'react'
import { DefaultAdminRolesRequiredPerAction } from '@nv/utils'
import { useTranslation } from 'react-i18next'

export const ConfigurationContext = createContext()

export const getDefaultConfiguration = (t) => ({
  languages: {
    en: 'English',
    fr: 'Francais',
  },
  votingMethodOptions: [
    { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },
    { label: t('admin.electorsList.votedChannelOptions.mail'), value: 'mail' },
  ],
  electionDate: new Date(),
  minAge: 18,
  registrationPhoneRequired: false,
  includeSingleNameField: false,
  maxSessionTimeMinsAdmin: 30,
  maxSessionTimeMinsVoter: 30,
  votingDistrictOptions: [],
  knownIdNumberTextFieldConfig: {},
  enableManualEntryAddress: true,
  enableSingleFieldMailingAddress: false,
  enableDifferentMailingAddress: true,
  mailingAddressRequiredVoteByMail: false,
  registrationOpensDate: '2025-01-20T00:00:00',
  displayStrikeOffOnlyVotingChannels: [],
  adminRolesPerAction: DefaultAdminRolesRequiredPerAction,
  contactInfoHelpSupport: false,
  contactInfoHelpSupportData: {},
  includeLoginButtonRegistrationPage: true,
  includeRegisterButtonRegistrationPage: true,
  includeLookupButtonRegistrationPage: false,
  voteReceiptVisibleAlways: true,
  adminToggleRegistrations: false,
  reverseStrikeOffEnabled: true,
  modules: {
    nominations: false,
  },
  voting: {
    enableVouching: false,
    enableAssisting: false,
  },
})

export const ConfigurationContextProvider = ({ children }) => {
  const { t } = useTranslation()
  const defaultConfiguration = getDefaultConfiguration(t)

  const value = useMemo(() => defaultConfiguration, [defaultConfiguration])

  return <ConfigurationContext.Provider value={value}>{children}</ConfigurationContext.Provider>
}

export const useConfigurationContext = () => useContext(ConfigurationContext)
